// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"16996a10","159":"c4ef6da3","421":"24b8221e","453":"f1a6b4c2"}[chunkId] + ".chunk.js";
};